export const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};
export const QUILL_MODULES_QUESTION = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    ["image"],
    ["clean"],
  ],
};

export const QUILL_FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];
export const QUILL_FORMATS_QUESTION = [
  // "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "image",
];

export const TINYMCE_PLUGINS = [
  "advlist autolink lists link image charmap print preview anchor",
  "searchreplace visualblocks code fullscreen",
  "insertdatetime media table paste code wordcount",
];

export const TINYMCE_TOOLBAR =
  "undo redo | formatselect | image | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat";

export const MAX_AUDIO_WAIT_TIME = 5; //seconds
export const AUTH_TOKEN = "AUTH_TOKEN";
export const USER_DATA = "USER_DATA";
export const USER_LOGIN = "LOGIN";
export const ESEWA = "ESEWA";
export const KHALTI = "KHALTI";
export const ESEWA_MERCHANT_CODE = process.env.REACT_APP_ESEWA_MERCHANT_CODE;
export const ESEWA_SECRET_KEY = process.env.REACT_APP_ESEWA_SECRET_KEY;
export const ESEWA_PAYMENT_URL = process.env.REACT_APP_ESEWA_PAYMENT_URL;
export const ESEWA_PAYMENT_VERIFICATION_URL =
  process.env.REACT_APP_ESEWA_PAYMENT_VERIFICATION_URL;
export const KHALTI_PUBLIC_KEY = process.env.REACT_APP_KHALTI_PUBLIC_KEY;
export const SITE = process.env.REACT_APP_SITE_URL;
export const DOMAIN = window.location.origin;
export const DOMAIN_PROTOCOL = window.location.protocol;
export const CLIENT_ID =
  "627308516970-sq8jbg710q489f0l4mkfsid07s5isk6o.apps.googleusercontent.com";

export const SLIDE_SETTING = {
  infinite: false,
  dots: false,
  arrows: false,
  autoplay: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
      },
    },
  ],
};

export const SERVICE_TYPES = [
  {
    value: "service",
    label: "Service",
  },
  {
    value: "country",
    label: "Country",
  },
  {
    value: "test",
    label: "Test",
  },
];

export const EXAM_DURATION_SECONDS = 3000;
export const ALERT_DURATION_SECONDS = 300;
